import React, { useState, useEffect } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { handleExportMatching, handleNewDealsList, matchingConversionList, showToast, usTimezone } from '../Utils/utils';
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';
import Loaderspinner from "../../components/Loader";
import { Tooltip } from 'react-tooltip'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment-timezone';
import "../MatchingConversion/style.css";

const MatchingConversion = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false)
  const [projectScope, setProjectScope] = useState("")
  const [amount, setAmount] = useState(0)
  const [startDate, setStartDate] = useState(moment().subtract(1, 'months').toDate());
  const [endDate, setEndDate] = useState(new Date());
  const [data, setData] = useState('');
  const [typeStatus, setTypeStatus] = useState("");

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true)
        const limit = 10;
        const offset = page * limit;
        const req = {
          limit: limit,
          offset: offset,
          filter: typeStatus,
          from: startDate != "" ? `${moment(startDate).tz('America/New_York').format('YYYY-MM-DD')} 00:00:00` : '',
          to: endDate != "" ? `${moment(endDate).tz('America/New_York').format('YYYY-MM-DD')} 23:59:59` : ''
        }
        const response = await matchingConversionList(req);
        // console.log(response.data)
        setData(response.data?.data)
        setProjectList(response?.data?.data?.projects || []);

        // if ((response?.data?.data.length || 0) < limit) {
        //   setTotalPages(page + 1);
        // } else {
        //   setTotalPages(page + 2);
        // }

      } catch (error) {
        console.error("Error fetching lenders:", error);
      } finally {
        setLoading(false)
      }
    };

    fetchProjects();
  }, [typeStatus, projectScope, amount, page]);



  const ExportList = async () => {
    try {
      setLoading(true);
      const limit = 10;
      const offset = page * limit;
      const req = {
        limit: limit,
        offset: offset,
        filter: typeStatus,
        from: startDate != "" ? `${moment(startDate).tz('America/New_York').format('YYYY-MM-DD')} 00:00:00` : '',
        to: endDate != "" ? `${moment(endDate).tz('America/New_York').format('YYYY-MM-DD')} 23:59:59` : ''
      }
      const blobData = await handleExportMatching(req);

      if (blobData.size === 6506) {
        showToast("No data available for export.", "error");
        return;
      }

      const blob = new Blob([blobData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "matching_conversion.csv");
      document.body.appendChild(link);

      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loaderspinner />}
      <div class="g-sidenav-show  bg-gray-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />

            <div className="header header-bg pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav
                        aria-label="breadcrumb"
                        className="d-none d-md-inline-block ml-md-4"
                      >
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                          <li className="breadcrumb-item">
                            <Link to="/dashboard">
                              <i className="fas fa-home" />
                            </Link>
                          </li>
                          <li className="breadcrumb-item mt-2">
                            <span className="" style={{ color: "#f6f9fc" }}> Match to funding conversion rate</span>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="d-flex justify-content-between">
                        <div className="row ">
                          <h5 className="mb-0 w-auto"> Match to funding conversion rate</h5>
                          <p
                            className="w-auto px-0"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content="Displays projects that have been posted within the last 7 days. Use this to track fresh opportunities and prioritize engagement with newly added projects."
                            data-tooltip-place="top"
                          >
                            <i className="fas fa-info-circle" />

                          </p>

                          <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                        </div>
                        <div className="mt-3 mt-lg-0 d-flex align-items-center filter">
                          <div style={{ marginRight: '5px', fontSize: '16px' }}>From Time : </div>
                          <DatePicker selected={startDate} onChange={(date) => setStartDate(date)}
                            className="custom-datepicker-input" dateFormat="yyyy-MM-dd" />
                          <div style={{ marginRight: '5px', fontSize: '16px' }}>To Time :  </div>
                          <DatePicker selected={endDate} onChange={(date) => setEndDate(date)}
                            className="custom-datepicker-input" dateFormat="yyyy-MM-dd" />
                          {/* <select
                            className="custom-select-dropdown mx-2"
                            value={typeStatus}
                            onChange={(e) => setTypeStatus(e.target.value)}
                          >
                            <option value="" className='option'>Status</option>
                            <option value="funding_requested" className='option'>Requested</option>
                            <option value="funding_approved" className='option'>Approved</option>
                            <option value="funding_secured" className='option'>Secured</option>
                            <option value="funding_completed" className='option'>Completed</option>
                          </select> */}
                          <button className='export-btn ml-0 ml-lg-3 mt-3 mt-lg-0 mx-2' onClick={() => {
                            setTypeStatus('')
                            setEndDate(new Date())
                            setStartDate(new Date())
                          }} ><span>Clear</span></button>
                          <button className='export-btn ml-0 ml-lg-3 mt-3 mt-lg-0 mx-2' onClick={ExportList} ><span>Export</span></button>
                        </div>

                      </div>
                    </div>
                    <div className="row gap-2 m-auto w-100 px-3" style={{ justifyContent: 'center' }}>
                      <div className={typeStatus == 'secured' ? "sec-btn-active" : 'sec-btn'} onClick={() => setTypeStatus('secured')}>
                        Matched : {data?.secured}
                      </div>
                      <div className={typeStatus == 'closed' ? "sec-btn-active" : 'sec-btn'} onClick={() => setTypeStatus('closed')}>
                        Closed : {data?.closed}
                      </div>
                      <div className="sec-btn">
                        Conversion : {data?.conversion}%
                      </div>
                    </div>
                    <div className="table-responsive mt-3">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th>Action</th>
                            <th>Project Name</th>
                            <th>Project Type</th>
                            <th>Created At</th>
                            <th>Created By</th>
                            <th>Funded By</th>
                            <th>Project Scope</th>
                            {/* <th>Location</th> */}
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {projectList?.length > 0 ? (
                            projectList.map((project, index) => (
                              <tr key={index}>
                                <td>
                                  <div style={{ width: "120px" }}>
                                    <Link to={`/view-project/${project?.id}`} target="_blank">
                                      <button className="viewproject-btn pull-right mb-1">
                                        <span className="text-white">View Project</span>
                                      </button>
                                    </Link>
                                  </div>
                                </td>

                                <td className="table-user">
                                  <div className="row w-100">
                                    <span className="w-auto">{project?.project_name}</span>

                                  </div>
                                </td>

                                <td className="table-user">
                                  <div>
                                    <span>{project?.type}</span>
                                  </div>
                                </td>

                                <td className="table-user">
                                  <div style={{ width: "120px" }}><span>{usTimezone(project?.created_at)}</span></div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}><span>{project?.user?.about?.name} {project?.user?.about?.lastname}</span></div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}><span>{project?.funder?.about?.name} {project?.funder?.about?.lastname}</span></div>
                                </td>

                                <td className="table-user">
                                  {project?.project_scope}
                                </td>

                                {/* <td className="table-user">
                                  <div>
                                    <div className="">{project?.location ? project?.location : " "} {project?.city} </div>
                                  </div>
                                </td> */}

                                <td className="table-user">
                                  <div>
                                    <div className="">{project?.needed} </div>
                                  </div>
                                </td>

                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center"><b>No records found</b></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <Row>
                <Col xs={12}>
                  <div className='paginate-css'>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={({ selected }) => setPage(selected)}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </main>
        </div>
      </div>
    </>

  )
}
export default MatchingConversion;